import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { UnsavedChangesDialogService } from '../../services/unsaved-changes-dialog.service';

export interface PendingChangesComponent {
  hasUnsavedChanges(): boolean;
  saveUnsavedChangesAsDraft(): Promise<boolean>;
  discardUnsavedChanges?(): void;
}

export const pendingChangesGuard: CanDeactivateFn<PendingChangesComponent> = async (component) => {
  if (!component?.hasUnsavedChanges?.()) {
    return true;
  }

  const dialog = inject(UnsavedChangesDialogService);
  const decision = await dialog.confirm();

  if (decision === 'stay') {
    return false;
  }

  if (decision === 'discard') {
    component.discardUnsavedChanges?.();
    return true;
  }

  const saved = await component.saveUnsavedChangesAsDraft();
  if (saved) {
    component.discardUnsavedChanges?.();
  }

  return saved;
};
